const login = "/api/user/login";
// 登录url
// const signout = "/api/user/signout";
const logout = '/api/user/logout'
// 退出

const register = "/api/user/register";
// 用户注册
const forgetpass = "/api/user/retrievepass";
// 忘记密码
const changeskin = "/api/user/usercolor";
// 换肤接口
const creatMeeting = "/api/meeting/creatMeeting";
// 创建会议
const addterminal = "/api/conference/addTerminalApi";
// 增加终端
// const broadcast = "/api/conference/broadcast";
const stopbroadcast = '/api/conference/stopBroadcastApi'
// 取消一键广播
const broadcast = '/api/conference/startBroadcastApi';
// 一键广播
const layout = '/api/conference/layoutApi'
//断开连接
const reConnectTerminal = '/api/conference/reConnectTerminal';
// 分屏模式
const savetemplate = '/api/conference/saveTemplateApi';
// 存为模板
const live = "/api/conference/live";
// 分享直播
const live2 = "/api/conference/liveApi";
// 分享直播2 wemeet/conference/live2
const radio = "/api/conference/audioApi"; // 音频控制
const video = "/api/conference/videoApi"; // 视频控制
const record = '/api/conference/recordApi';
// 会议录制
const lockAPI = "/api/conference/lockApi";
// 会议锁定

const deleteParty = '/api/conference/deleteParty';

// 结束会
const closeConf = '/api/conference/terminateConference';

const callroll = '/api/conference/selectPartyApi';
// 一键点名

const stopcallroll = '/api/conference/unselectPartyApi'
// 
const getMeetingDetails = '/api/conference/getMeetingDetails';	//只需1个参数
// 设置主会场
const setLecture = '/api/conference/setLectureApi'

//  取消主会场
const unsetLecture = '/api/conference/unsetLectureApi'

const userslist = "/api/user/list";
// 获取人员列表
const roomslist = "/api/terminal/list";
// 获取人员列表
const changepassword = "/api/user/changepass";
// 修改密码
const changepassword2 = "/api/user/forget_changepass";

// 获取正在举行会议列表
const getmeetindetail = "/api/conference/get";

// 获取会议详情
const terminallists = "/api/terminal/list";
//终端部门获取树形结构
const getDepartmentsAndTerminals = "/api/terminal/getDepartmentsAndTerminals"
//终端日历请求数据
const getDepartmentsAndTersBySearch = "/api/terminal/getDepartmentsAndTersBySearch"
//获取终端时间列表
const findTerminalListAndCalendar = '/api/terminal/findTerminalListAndCalendar'
//获取全部的终端列表
const getAllTerminals = '/api/terminal/getAllTerminals'
//设备资源占用
const findDevOccupied = "/api/device/findDevOccupied"

//根据部门过去详情
const findterminallistAndStatus = '/api/terminal/findterminallistAndStatus'
// 删除预约会议 meeting/delete?
// const delmeeting = "/api/meeting/delete";
const delmeeting = '/api/meeting/deleteConf';
// 修改预约会议
// const changemeeting = "/api/meeting/edit";
const changemeeting = '/api/meeting/editFutureConf';

// 增加人员
const addusr = "/api/conference/addUserApi";

// 获得用户信息user/getuserInfo
const usermessage = "/api/user/getuserInfo";
// 修改用户user/edit
const editusermessage = "/api/user/edit";
// 获取设备信息systemsetting/getinfo
const systemmessage = "/api/systemsetting/getinfo";

/***************以下为新接口*****************/
// 获取第一级部门
const getFirstDepartment = "/api/user/getDepartmentsAndUsers";
//获取一级部门下的子部门
const getUserByDepartmentId1 = '/api/user/getUserByDepartmentId1'
// 获取第二级部门
const getSecondDepartment = "/api/user/getSecondDepartment";

// 查询部门下的用户
const getUserByDepartmentId = "/api/user/getUserByDepartmentId";

// 获取会议模板列表
const getMeetingTemplateList = "/api/meeting_template/getMeeting_templateList";

// 正在进行的会议列表
// const getNowMeetingListByDepartmentId ="/api/conference/getNowConfList";
const getNowMeetingListByDepartmentId = "/api/conference/getOngoingMeetings";

// 删除会议模板
const deleteMeetingTemplate = "/api/meeting_template/delete_meetingTemplate";

// 会议模板详情
const getMeetingTemplateInfo = "/api/meeting_template/getmeeting_templateInfo";

// 会议模板编辑
const update_MeetingTemplateById = '/api/meeting_template/update_MeetingTemplateById';

// 终端列表
const terminalList = "/api/terminal/list";

// 终端时间详情
const findTerminalTimeById = "/api/terminal/findTerminalTimeById";

// 预约历史点播会议列表查询
const selectConfList = "/api/meeting/selectConfList";

// 预约历史点播会议详情
const selectConfDetail = "/api/meeting/selectConfDetail";

// 正在举行的某个会议的详情
const getTerminalsOfCf = "/api/conference/getTerminalsOfCfYsy";
// 只有主会场的终端才有双流
const masterPartylist = '/api/conference/masterPartylist';

// 广播轮询
const broadcastPolling = "/api/conference/setBroadcastPoll";

// 一键轮询
// const keyPolling = "/api/conference/keyPolling";
const keyPolling = "/api/conference/setKeyPoll";

// 签到记录
const selectSignin = "/api/conference/selectSigninApi";

// 双流功能
const doubleCurrent = '/api/conference/doubleCurrentApi';

// 取消双流功能
const doubleCurrentClean = '/api/conference/doubleCurrentCleanApi'

// 终端列表（含状态信息）
const findTerminalsByDepartmentId = '/api/';
//签到接口
const setSignIn = "/api/signIn/setSignIn"

//微信登录
const wxLogin = "/api/wechat/getWechatInfo";
//微信menu
const wxMenu = "/api/wechat/menu"

// 安排会议界面录播直播按钮是否显示
const beforeCreateMeeting = "/api/meeting/beforeCreate"
//扫描鉴权
const Auth="/api/vv/auth"//(get请求)
//鉴权信息
 const AuthuserInfo="/api/vv/getUserInfo"//(post请求)
 const AuthuserInfo_get="/api/vv/getUserInfo_get"//(get请求)
//扫码终端加入会议
const JoinMeeting = "/api/conference/joinMeeting"
//获取会议模式
const MeetingPattern="/api/conference/getServiceTemplates"
//获取注册验证码
const getVeriCodeImg="/api/user/veriCodeImg"
//获取会议列表给万科VV 
const getMeetingsForVV="/api/conference/getMeetingsForVV"

//获取企业定制化信息
const getEntSettingInfo="/api/sysconfig/getEntSettingInfo"

export {
  login,
  logout,
  register,
  forgetpass,
  changeskin,
  creatMeeting,
  addterminal,
  broadcast,
  layout,
  savetemplate,
  live,
  live2,
  radio,
  video,
  record,
  lockAPI,
  callroll,
  userslist,
  roomslist,
  changepassword,
  getmeetindetail,
  terminallists,
  changepassword2,
  delmeeting,
  changemeeting,
  addusr,
  usermessage,
  editusermessage,
  systemmessage,
  getFirstDepartment,
  getSecondDepartment,
  getUserByDepartmentId,
  getMeetingTemplateList,
  getNowMeetingListByDepartmentId,
  deleteMeetingTemplate,
  getMeetingTemplateInfo,
  update_MeetingTemplateById,
  terminalList,
  findTerminalTimeById,
  selectConfList,
  selectConfDetail,
  getTerminalsOfCf,
  masterPartylist,
  broadcastPolling,
  keyPolling,
  selectSignin,
  doubleCurrent,
  doubleCurrentClean,
  findTerminalsByDepartmentId,
  reConnectTerminal,
  findterminallistAndStatus,
  getDepartmentsAndTerminals,
  getDepartmentsAndTersBySearch,
  findTerminalListAndCalendar,
  getAllTerminals,
  findDevOccupied,
  getUserByDepartmentId1,
  setSignIn,
  wxLogin,
  wxMenu,
  beforeCreateMeeting,
  setLecture,
  getMeetingDetails,
  unsetLecture,
  stopcallroll,
  stopbroadcast,
  closeConf,
  Auth,
  AuthuserInfo,
  AuthuserInfo_get,
  JoinMeeting,
  deleteParty,
  MeetingPattern, 
  getVeriCodeImg,
  getMeetingsForVV,
  getEntSettingInfo
}



// WEBPACK FOOTER //
// ./src/assets/js/url.js